export const socialsData = {
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/dinda-firly-amalia-b10165118/',
    instagram: 'https://www.instagram.com/dinzenglish/',
    twitter: 'https://twitter.com/',
}